import {Collapse, Modal} from "antd";
import React from "react";
const { Panel } = Collapse;

const SportLogModal = ({open, onClose, items}) => {
  return (
    <Modal open={open} title='Bet Log' onCancel={onClose} footer={null} width={650}>
      <Collapse>
        {items?.map((item) => {
          const request = JSON.parse(item.request)
          return (
            <Panel header={`${item.type} (${item.created_at})` } key={item.id}>
              <pre>{JSON.stringify(request, null, 2)}</pre>
            </Panel>
          )
          }
        )}
      </Collapse>
    </Modal>
  )
}

export default SportLogModal;